export const baseUrl = '/kpis'
